import { cva } from "class-variance-authority";
import { Loader } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { ButtonProps } from "./shared";

type Props = React.ComponentProps<"button"> & ButtonProps

const Button = ({
    children,
    disabled,
    intent,
    size,
    loading,
    leftIcon,
    rightIcon,
    className,
    ...props
}: Props) => {

    const buttonClass = () => {
        const defaultClass = `relative inline-flex justify-center items-center 
        rounded-lg border font-medium transition-all duration-500 ease-in-out 
        outline-none focus:outline-none outline outline-offset-2 mx-1`

        const config = {
            variants: {
                intent: {
                    primary: "bg-primary text-white border-primary hover:bg-primary-600 outline-primary",

                    secondary: "bg-white text-primary border-primary hover:bg-primary-50 outline-0",

                    danger: "bg-rose-800 text-white border-rose-800 hover:bg-rose-700 outline-0",

                    default: "bg-secondary-50 hover:bg-secondary-100 text-secondary border-secondary-100 outline-secondary-100",

                    text: "bg-transparent border-transparent outline-0"
                },
                size: {
                    sm: "px-4 py-2 text-xs",
                    md: "px-4 py-2.5 min-w-24 text-sm",
                    lg: "px-4 py-3 min-w-24 text-base"
                }
            }
        }

        return cva(defaultClass, config)({
            intent: intent,
            size: size ?? "sm"
        })
    }


    return (

        <button
            className={twMerge(buttonClass(), className)}
            disabled={loading || disabled}
            {...props}
        >

            {
                loading && (
                    <div className="absolute z-10 inset-0 flex justify-center items-center">
                        <Loader 
                            className="w-5 h-5 animate-spin" 
                        />
                    </div>
                )
            }

            <div className={twMerge(
                loading && "invisible",
                leftIcon && "mr-2"
            )}>
                {leftIcon}
            </div>

            <span className={twMerge(loading && "invisible")}>
                {children}
            </span>

            <div className={twMerge(
                loading && "invisible",
                rightIcon && "ml-2"
            )}>
                {rightIcon}
            </div>
        </button>
    )
}

export default Button